import toast from "react-hot-toast";
import * as api from "../Api";

export const unapprovedAdvices = () => async (dispatch) => {
  try {
    const { data } = await api.getUnapprovedAdvice();
    dispatch({ type: "UNAPPROVED_ADVICE", payload: data });
  } catch (error) {}
};

export const approveAdvice = (id, postData) => async (dispatch) => {
  let approvingId;
  try {
    approvingId = toast.loading("approving advice....");
    await api.updateAdvice(id, postData);
    dispatch({ type: "APPROVE_ADVICE", payload: id });
    toast.remove(approvingId);
    toast.success("advice successfully approved");
  } catch (error) {
    toast.remove(approvingId);
    toast.error(error.message);
  }
};

export const deleteAdvice = (id) => async (dispatch) => {
  let approvingId;
  try {
    approvingId = toast.loading("deleting advice...");
    await api.deleteAdvice(id);
    dispatch({ type: "DELETE_ADVICE", payload: id });
    toast.remove(approvingId);
    toast.success("successfully deleted");
  } catch (error) {
    toast.remove(approvingId);
    toast.error(error.message);
  }
};
